/** A whole number of minor units (or a whole multiplier): the wire's amounts are digit strings. */
const WHOLE = /^\d+$/;

/**
 * "base × multiplier → total" for a win the server multiplied, only when that reads true (decision 60): every line
 * carries the same whole multiplier above 1 and its base, and the bases' sum times the multiplier is the amount paid.
 * A group mixing multipliers (a ×1 line beside a ×N line), a line without its base, or an amount the server trimmed
 * (a max-win cap) shows the plain amount instead. BigInt-safe; whole minor units only, anything else shows none.
 */
export function multiplierBreakdown(
  lines: ReadonlyArray<{ baseWinAmount?: string; multiplierApplied?: string }> | undefined,
  finalAmount: string | undefined,
): { base: string; multiplier: string } | undefined {
  if (!lines || lines.length === 0 || !finalAmount || !WHOLE.test(finalAmount)) return undefined;
  const multiplier = lines[0]!.multiplierApplied;
  if (!multiplier || !WHOLE.test(multiplier) || BigInt(multiplier) <= 1n) return undefined;
  let baseSum = 0n;
  for (const line of lines) {
    if (!line.multiplierApplied || !WHOLE.test(line.multiplierApplied) || BigInt(line.multiplierApplied) !== BigInt(multiplier)) return undefined;
    if (!line.baseWinAmount || !WHOLE.test(line.baseWinAmount)) return undefined;
    baseSum += BigInt(line.baseWinAmount);
  }
  if (baseSum <= 0n || baseSum * BigInt(multiplier) !== BigInt(finalAmount)) return undefined;
  return { base: baseSum.toString(), multiplier: BigInt(multiplier).toString() };
}
